import React from 'react';
import util from 'Utils/commonUtil';
import {T} from 'Actions/translate';

// Components
import ProductItem from 'Components/commonOrder/ProductItem';
import BasicButton from 'Components/common/BasicButton';

import {
    ORDER_TYPE,
    MY_ORDER_STATUS,
    USER_ROLE,
    PRODUCT_SOURCE,
    OrderTypeEnum,
} from 'Utils/constant';

// Icons
import {Timer} from '@material-ui/icons';

class OrderProductList extends React.Component {
    toNumber = (value) => {
        return Number(value || 0);
    };

    getNotShippedQuantity = (orderProduct) =>
        Number(
            (orderProduct && orderProduct.tobeshippedQuantity) ||
                (orderProduct && orderProduct.onholdQuantity) ||
                0,
        );

    isFullyShipped = (orderProduct) =>
        this.getNotShippedQuantity(orderProduct) === 0;

    shouldShowShippingPlanButton = (orderData) => {
        const {tabFlag} = this.props;

        return (
            orderData.orderType === ORDER_TYPE.SCM &&
            orderData.status === MY_ORDER_STATUS.ONHOLD &&
            tabFlag !== 3
        );
    };

    shouldShowShippingPlanButtonForProduct = (orderData, orderProduct) =>
        this.shouldShowShippingPlanButton(orderData) &&
        this.getNotShippedQuantity(orderProduct) > 0;

    getShipmentQuantity(productId) {
        const {data} = this.props;
        let quantity = 0;

        data.shipments &&
            data.shipments.forEach((shipment) => {
                shipment.shipmentProducts &&
                    shipment.shipmentProducts.forEach((shipmentProduct) => {
                        if (shipmentProduct.orderProductId === productId) {
                            quantity += shipmentProduct.quantity;
                        }
                    });
            });

        return quantity;
    }

    getOrderQuantity(isShipment) {
        const {data} = this.props;
        let quantity = 0;

        data.orderProducts &&
            data.orderProducts.forEach((product) => {
                quantity += product.quantity;
            });

        return quantity;
    }

    showInventoryLogisticsDetails = (supplyCenterId, productId, eoneNumber) => {
        this.props.showSkuInventoryDetailHandle(
            supplyCenterId,
            productId,
            eoneNumber,
        );
    };

    openShippingPlanDialog = (data, orderProduct) => {
        this.props.openShippingPlan(data, orderProduct);
    };

    getSku = (orderProduct) => {
        return (
            (orderProduct &&
                orderProduct.product &&
                orderProduct.product.sku) ||
            ''
        );
    };

    getPriceKey = (orderProduct) => {
        const discountPrice = orderProduct && orderProduct.discountPrice;

        if (discountPrice === null || typeof discountPrice === 'undefined') {
            return '';
        }

        const price = Number(discountPrice);

        return Number.isNaN(price) ? `${discountPrice}` : price.toFixed(2);
    };

    isOemProduct = (orderProduct) =>
        orderProduct &&
        orderProduct.product &&
        orderProduct.product.productSource === PRODUCT_SOURCE.OEM;

    isOemProductWithoutPrice = (orderProduct, orderType) =>
        orderType === ORDER_TYPE.SCM &&
        this.isOemProduct(orderProduct) &&
        (orderProduct.discountPrice === null ||
            typeof orderProduct.discountPrice === 'undefined' ||
            orderProduct.totalPrice === null ||
            typeof orderProduct.totalPrice === 'undefined');

    getGroupKey = (orderProduct) => {
        return `${this.getSku(orderProduct)}_${this.getPriceKey(orderProduct)}`;
    };

    getShipmentDate = (shipment) => {
        return (
            (shipment &&
                shipment.createTime &&
                shipment.createTime.slice(0, 10)) ||
            ''
        );
    };

    addQuantityByKey = (list, key, item) => {
        const matchedItem = list.find((row) => row.key === key);

        if (matchedItem) {
            matchedItem.quantity += item.quantity;
        } else {
            list.push(item);
        }
    };

    isCanceledShipment = (shipment) => {
        return shipment && this.toNumber(shipment.status) === -1;
    };

    buildOrderProductGroups = (data) => {
        const orderProducts = data.orderProducts || [];
        const groups = [];
        const groupMap = {};
        const productIdGroupMap = {};

        orderProducts.forEach((orderProduct) => {
            const groupKey = this.getGroupKey(orderProduct);
            let group = groupMap[groupKey];

            if (!group) {
                group = {
                    key: groupKey,
                    product: orderProduct,
                    orderProducts: [],
                    shippedItems: [],
                    notShippedItems: [],
                    shippedQuantity: 0,
                    fallbackShippedQuantity: 0,
                    notShippedQuantity: 0,
                    totalQuantity: 0,
                    haveShippingPlan: false,
                };
                groupMap[groupKey] = group;
                groups.push(group);
            }

            group.orderProducts.push(orderProduct);
            group.haveShippingPlan =
                group.haveShippingPlan || !!orderProduct.haveShippingPlan;
            productIdGroupMap[orderProduct.id] = group;
            group.fallbackShippedQuantity +=
                this.toNumber(orderProduct.shippedQuantity) +
                this.toNumber(orderProduct.receivedQuantity);

            const notShippedQuantity = this.getNotShippedQuantity(orderProduct);

            if (notShippedQuantity > 0) {
                group.notShippedItems.push({
                    key: orderProduct.id,
                    crd: orderProduct.crd,
                    quantity: notShippedQuantity,
                    orderProduct,
                });
                group.notShippedQuantity += notShippedQuantity;
            }
        });

        (data.shipments || []).forEach((shipment) => {
            if (this.isCanceledShipment(shipment)) {
                return;
            }

            (shipment.shipmentProducts || []).forEach((shipmentProduct) => {
                const group =
                    productIdGroupMap[shipmentProduct.orderProductId] ||
                    groupMap[this.getGroupKey(shipmentProduct)];
                const quantity = this.toNumber(shipmentProduct.quantity);

                if (!group || quantity <= 0) {
                    return;
                }

                const shipmentDate = this.getShipmentDate(shipment);

                this.addQuantityByKey(group.shippedItems, shipmentDate, {
                    key: shipmentDate,
                    shipmentDate,
                    quantity,
                });
                group.shippedQuantity += quantity;
            });
        });

        groups.forEach((group) => {
            if (
                !group.shippedItems.length &&
                group.fallbackShippedQuantity > 0
            ) {
                group.shippedItems.push({
                    key: 'fallback-shipped',
                    shipmentDate: '',
                    quantity: group.fallbackShippedQuantity,
                });
                group.shippedQuantity = group.fallbackShippedQuantity;
            }

            group.totalQuantity =
                group.shippedQuantity + group.notShippedQuantity;
        });

        return groups;
    };

    getGroupProduct = (group) => {
        return {
            ...group.product,
            quantity: group.totalQuantity,
            haveShippingPlan: group.haveShippingPlan,
        };
    };

    getActionProduct = (group) => {
        return (
            group.orderProducts.find(
                (orderProduct) => this.getNotShippedQuantity(orderProduct) > 0,
            ) || group.product
        );
    };

    shouldShowSalesShippingPlanTip = (orderData, orderProduct) => {
        return (
            this.props.roleType !== USER_ROLE.HOST &&
            !!orderProduct.crd &&
            !this.isFullyShipped(orderProduct) &&
            this.shouldShowShippingPlanButton(orderData)
        );
    };

    shouldShowGroupSalesShippingPlanTip = (orderData, group) => {
        return group.orderProducts.some((orderProduct) => {
            return this.shouldShowSalesShippingPlanTip(orderData, orderProduct);
        });
    };

    renderShipmentSection = (
        title,
        rows,
        firstColumnTitle,
        getFirstColumnValue,
        isShipped = false,
        renderAction = null,
    ) => {
        const shouldShowActionColumn =
            !!renderAction && rows.some((row) => !!renderAction(row));
        const shouldAlignQuantityToActionColumn =
            isShipped || !shouldShowActionColumn;

        return (
            <div className={`order-product-shipment-section`}>
                <div
                    className={`shipment-section-title ${
                        isShipped ? 'shipped' : 'not-shipped'
                    }`}>
                    {title}
                </div>
                <div className="shipment-section-flex">
                    <div className="shipment-section-row shipment-section-header">
                        <div className="shipment-section-col">
                            {firstColumnTitle}
                        </div>
                        <div
                            className={`shipment-section-col shipment-section-quantity-col ${
                                shouldAlignQuantityToActionColumn
                                    ? 'shipment-section-quantity-col-placeholder'
                                    : ''
                            }`}>
                            {shouldAlignQuantityToActionColumn
                                ? null
                                : T('shipping_plan_quantity')}
                        </div>
                        {shouldShowActionColumn ||
                        shouldAlignQuantityToActionColumn ? (
                            <div className="shipment-section-col shipment-section-action-col">
                                {shouldAlignQuantityToActionColumn
                                    ? T('shipping_plan_quantity')
                                    : T('common_operation')}
                            </div>
                        ) : null}
                    </div>
                    {rows.map((row) => (
                        <div key={row.key} className="shipment-section-row">
                            <div className="shipment-section-col">
                                {getFirstColumnValue(row) || T('order_no_name')}
                            </div>
                            <div
                                className={`shipment-section-col shipment-section-quantity-col ${
                                    shouldAlignQuantityToActionColumn
                                        ? 'shipment-section-quantity-col-placeholder'
                                        : ''
                                }`}>
                                {shouldAlignQuantityToActionColumn
                                    ? null
                                    : row.quantity}
                            </div>
                            {shouldShowActionColumn ||
                            shouldAlignQuantityToActionColumn ? (
                                <div className="shipment-section-col shipment-section-action-col">
                                    {shouldAlignQuantityToActionColumn
                                        ? row.quantity
                                        : renderAction(row)}
                                </div>
                            ) : null}
                        </div>
                    ))}
                </div>
            </div>
        );
    };

    render() {
        const {className, data, roleType} = this.props;
        const options = this.props.options || {};
        const webOrderType = data.webOrderType;
        const shouldUseGroupedProductList =
            options.showQuantity &&
            data.orderType !== OrderTypeEnum.SO &&
            data.orderType !== OrderTypeEnum.SE;
        const orderProductGroups =
            shouldUseGroupedProductList && this.buildOrderProductGroups(data);
        let isDisplayInventoryDetail = false;
        if (
            webOrderType === 'D1' ||
            webOrderType === 'D2' ||
            webOrderType === 'CR'
        ) {
            isDisplayInventoryDetail = true;
        }
        return (
            <div className={className}>
                <h4 className="products-title">
                    {T('product_infomation')}
                    <span>
                        {T('porduct_total_quantity', [this.getOrderQuantity()])}{' '}
                        <b className="price">
                            <i className="rmb"></i>{' '}
                            <b className="price-number">
                                {data.totalPrice
                                    ? util.toMoney(data.totalPrice)
                                    : '0.00'}
                            </b>
                        </b>
                    </span>
                </h4>
                <ul>
                    {shouldUseGroupedProductList &&
                        orderProductGroups &&
                        orderProductGroups.map((group, index) => {
                            const p = this.getGroupProduct(group);
                            const actionProduct = this.getActionProduct(group);

                            return (
                                <li
                                    key={group.key || index}
                                    className={
                                        group.haveShippingPlan
                                            ? 'have-shipping-plan'
                                            : ''
                                    }>
                                    {group.haveShippingPlan ? <Timer /> : null}
                                    <div className="order-product-group-card">
                                        <ProductItem
                                            item={p}
                                            inventoryKey={options.inventoryKey}
                                            className={
                                                group.haveShippingPlan
                                                    ? 'order-detail-have-shipping-plan'
                                                    : ''
                                            }
                                            roleType={roleType}
                                            showCrd={false}
                                            orderType={data.orderType}
                                            showInventoryDetail={
                                                roleType !== 'undefined' &&
                                                roleType !== 0 &&
                                                isDisplayInventoryDetail &&
                                                (actionProduct.tobeshippedQuantity >
                                                    0 ||
                                                    actionProduct.onholdQuantity >
                                                        0)
                                            }
                                            inventoryDetailAction={() => {
                                                this.showInventoryLogisticsDetails(
                                                    data.supplyCenterId,
                                                    actionProduct.productId,
                                                    data.eoneNumber,
                                                );
                                            }}>
                                            <div className="price-box">
                                                <span className="price number-font price-font">
                                                    {this.isOemProductWithoutPrice(
                                                        p,
                                                        data.orderType,
                                                    ) ? (
                                                        T(
                                                            'oem_custom_order_product',
                                                        )
                                                    ) : (
                                                        <>
                                                            <i className="rmb"></i>{' '}
                                                            <b>
                                                                {util.toMoney(
                                                                    p.discountPrice,
                                                                )}
                                                            </b>{' '}
                                                            {T(
                                                                'porduct_discount_price',
                                                            )}
                                                        </>
                                                    )}
                                                </span>
                                                <span className="quantity">
                                                    X{group.totalQuantity}
                                                </span>
                                            </div>
                                            {this.shouldShowGroupSalesShippingPlanTip(
                                                data,
                                                group,
                                            ) ? (
                                                <div className="group-sales-shipping-plan-tip">
                                                    {T(
                                                        'sales_shipping_plan_sync_reminder',
                                                    )}
                                                </div>
                                            ) : null}
                                            {/* {options.showShipQuantity ? (
                                                <div className="quantity-box">
                                                    {T(
                                                        'current_shippment_quantity_colon',
                                                    )}{' '}
                                                    {group.shippedQuantity}
                                                </div>
                                            ) : null} */}
                                        </ProductItem>
                                        {group.notShippedItems.length
                                            ? this.renderShipmentSection(
                                                  T(
                                                      'order_product_group_not_shipped',
                                                  ),
                                                  group.notShippedItems,
                                                  T('product_crd_date'),
                                                  (row) => {
                                                      return row.crd;
                                                  },
                                                  false,
                                                  (row) => {
                                                      return roleType !==
                                                          'undefined' &&
                                                          roleType !== 0 &&
                                                          this.shouldShowShippingPlanButtonForProduct(
                                                              data,
                                                              row.orderProduct,
                                                          ) ? (
                                                          <BasicButton
                                                              type="info"
                                                              className="cancel-btn shipping-plan-btn shipment-section-action-btn"
                                                              onClickOfSingleTap={() =>
                                                                  this.openShippingPlanDialog(
                                                                      data,
                                                                      row.orderProduct,
                                                                  )
                                                              }>
                                                              {T(
                                                                  'shipping_plan',
                                                              )}
                                                          </BasicButton>
                                                      ) : null;
                                                  },
                                              )
                                            : null}
                                        {group.shippedItems.length
                                            ? this.renderShipmentSection(
                                                  T(
                                                      'order_product_group_shipped',
                                                  ),
                                                  group.shippedItems,
                                                  T('shippment_delivery_date'),
                                                  (row) => {
                                                      return row.shipmentDate;
                                                  },
                                                  true,
                                              )
                                            : null}
                                    </div>
                                </li>
                            );
                        })}
                    {!shouldUseGroupedProductList &&
                        data.orderProducts &&
                        data.orderProducts.map((p, index) => (
                            <li
                                key={index}
                                className={
                                    p.haveShippingPlan
                                        ? 'have-shipping-plan'
                                        : ''
                                }>
                                {p.haveShippingPlan ? <Timer /> : null}
                                <ProductItem
                                    item={p}
                                    inventoryKey={options.inventoryKey}
                                    className={
                                        p.haveShippingPlan
                                            ? 'order-detail-have-shipping-plan'
                                            : ''
                                    }
                                    roleType={roleType}
                                    showCrd={!this.isFullyShipped(p)}
                                    showSalesShippingPlanTip={
                                        roleType !== USER_ROLE.HOST &&
                                        !!p.crd &&
                                        !this.isFullyShipped(p) &&
                                        this.shouldShowShippingPlanButton(data)
                                    }
                                    orderType={data.orderType}>
                                    <div className="price-box">
                                        <span className="price number-font price-font">
                                            {this.isOemProductWithoutPrice(
                                                p,
                                                data.orderType,
                                            ) ? (
                                                T('oem_custom_order_product')
                                            ) : (
                                                <>
                                                    <i className="rmb"></i>{' '}
                                                    <b>
                                                        {util.toMoney(
                                                            p.discountPrice,
                                                        )}
                                                    </b>{' '}
                                                    {T(
                                                        'porduct_discount_price',
                                                    )}
                                                </>
                                            )}
                                        </span>
                                        <span className="quantity">
                                            X{p.quantity}
                                        </span>
                                    </div>
                                    {options.showShipQuantity ? (
                                        <div className="quantity-box">
                                            {T(
                                                'current_shippment_quantity_colon',
                                            )}{' '}
                                            {this.getShipmentQuantity(p.id)}
                                        </div>
                                    ) : null}
                                    {options.showQuantity ? (
                                        <div className="quantity-box">
                                            <span className="shipped-quantity">
                                                {T('shippment_quantity_colon')}{' '}
                                                {p.shippedQuantity +
                                                    p.receivedQuantity}
                                            </span>
                                            <span className="tobeship-quantity">
                                                {T(
                                                    'not_shippment_quantity_colon',
                                                )}{' '}
                                                {p.tobeshippedQuantity ||
                                                    p.onholdQuantity}
                                            </span>
                                        </div>
                                    ) : null}

                                    {roleType !== 'undefined' &&
                                    roleType !== 0 ? (
                                        <div
                                            className={
                                                p.estimatedShippingDate &&
                                                roleType !== USER_ROLE.HOST
                                                    ? 'sku-inventory-detail'
                                                    : 'sku-inventory-detail'
                                            }>
                                            {isDisplayInventoryDetail &&
                                                (p.tobeshippedQuantity > 0 ||
                                                    p.onholdQuantity > 0) && (
                                                    <BasicButton
                                                        type="info"
                                                        className="cancel-btn inventory-detail-btn"
                                                        onClickOfSingleTap={() =>
                                                            this.showInventoryLogisticsDetails(
                                                                data.supplyCenterId,
                                                                p.productId,
                                                                data.eoneNumber,
                                                            )
                                                        }>
                                                        {T(
                                                            'fone_order_inventory_details',
                                                        )}
                                                    </BasicButton>
                                                )}

                                            {this.shouldShowShippingPlanButtonForProduct(
                                                data,
                                                p,
                                            ) ? (
                                                <BasicButton
                                                    type="info"
                                                    className="cancel-btn shipping-plan-btn"
                                                    onClickOfSingleTap={() =>
                                                        this.openShippingPlanDialog(
                                                            data,
                                                            p,
                                                        )
                                                    }>
                                                    {T('shipping_plan')}
                                                </BasicButton>
                                            ) : null}
                                        </div>
                                    ) : null}
                                </ProductItem>
                            </li>
                        ))}
                </ul>
            </div>
        );
    }
}

export default OrderProductList;
